import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useBrandCustomProfile from '@hooks/useBrandCustomProfile'
import useSelector from '@hooks/useSelector'

import { confirmDelete } from '@functions/entity'

import type { BrandCustomProfileModel } from '@models/types'

interface BrandCustomProfileListItemProps {
  brandCustomProfile: BrandCustomProfileModel,
  filterKey: string,
}

const BrandCustomProfileListItem = (props: BrandCustomProfileListItemProps) => {
  const {
    brandCustomProfile: initBrandCustomProfile,
    filterKey,
  } = props

  const {
    brandCustomProfile: {
      id, profile_type, role_id, title,
    },
    callbacks: { createOrEditBrandCustomProfileModal, deleteBrandCustomProfile: deleteFn },
  } = useBrandCustomProfile(initBrandCustomProfile)

  const roles = useSelector(reduxState => reduxState.entities.roles)
  const role = roles[role_id]

  if (filterKey !== profile_type) return null

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    options: {
      entityParams: { id },
    },
    strings: {
      confirmString: 'Are you sure? This will delete this profile.',
      entityName: 'Brand Custom Profile',
    },
  }

  return (
    <DashboardModuleListItem
      boxProps={{
        borderBottom: 'none',
        borderTop: '1px solid',
      }}
      childrenHolderProps={{ padding: 'small' }}
      secondaryText={role?.title}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditBrandCustomProfileModal()}
          type="edit"
        />
        {/*
       // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default BrandCustomProfileListItem
